export interface DimensionValue {
  id: string
  name: string
}

interface BaseDimensionAssignment {
  id: number
  name: string
  options: DimensionValue[]
}

export type SingleValueDimensionAssignment = BaseDimensionAssignment & {
  type: 'single-value'
  assignmentValue?: DimensionValue
  membershipId?: number
}

export type MutipleValueDimensionAssignment = BaseDimensionAssignment & {
  type: 'multiple-value'
  assignments: (DimensionValue & { percentage: number })[]
}

export type DimensionWithEmployeeAssignment =
  | SingleValueDimensionAssignment
  | MutipleValueDimensionAssignment

export const UNASSIGNED = 'unassigned'
